'use strict';

export default angular
  .module('maestro.services.data.stories', [
    'maestro.services.webcore'
  ])
  .service('StoriesService', StoriesService)
  .name;

function StoriesService(webcore, $q, CacheService) {

  /**
   * Gets entity stories.
   * @param [params] Request parameters.
   * @param {string} [params.storyId] Get specific story by ID.
   * @param {string} [params.modelId] Filter stories by device model.
   * @param {string} [params.brand] Filter stories by brand.
   * @param {string} [params.lang] Get stories for specific language, otherwise stories for all languages returned.
   * @param {boolean} [params.hidden] Request hidden pages, which are not returned by default.
   * @param {string} [params.searchBy] Search criterion. Use * for a wildcard.
   * @param {number} [params.storyType] Filter stories by type.
   * @returns {Promise}
   */
  this.getStories = CacheService.cachePromiseFunc((params) => {
    return $q.when(
      webcore.services.stories.getStories(params)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  });

  /**
   * Get story by id
   * @param {string} storyId
   * @returns {Promise}
   */
  this.getStory = (storyId) => {
    return this.getStories({ storyId: storyId });
  };

}
